<!-- youtube-mobile-06 preview — YouTube watch page, landscape player + companion card -->
<app-mobile-frame>
  <div class="yt-m-watch d-flex flex-column">
    <!-- START: Player -->
    <a class="yt-m-watch-player d-block" [href]="data.url || null" target="_blank" rel="noopener noreferrer">
      <img *ngIf="creativeImage; else missing" class="yt-m-watch-image" [src]="creativeImage" alt="" />
      <ng-template #missing>
        <div class="yt-m-watch-missing">{{ missingDimensionLabel }}</div>
      </ng-template>

      <span class="yt-m-watch-channel d-flex flex-row align-items-center gap-2">
        <img
          class="yt-m-watch-logo"
          src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
          alt=""
        />
        <span class="yt-m-watch-channel-text d-flex flex-column">
          <strong>{{ data.headlines[0] || "Your headline appears here" }}</strong>
          <small>Valamar</small>
        </span>
      </span>
      <span class="yt-m-watch-visit">Visit advertiser</span>

      <span class="yt-m-watch-play"><i class="bi bi-play-fill"></i></span>

      <span class="yt-m-watch-sponsored">Sponsored <i class="bi bi-info-circle"></i></span>
      <span class="yt-m-watch-on-yt">Gledajte na <i class="bi bi-youtube"></i> YouTube</span>
    </a>
    <!-- END: Player -->

    <!-- START: Companion card -->
    <div class="yt-m-comp d-flex flex-column">
      <div class="yt-m-comp-head d-flex flex-row align-items-center">
        <strong class="flex-grow-1">Sponsored</strong>
        <i class="bi bi-three-dots-vertical"></i>
        <i class="bi bi-x-lg"></i>
      </div>

      <div class="yt-m-comp-body d-flex flex-column align-items-center text-center">
        <img
          class="yt-m-comp-logo"
          src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
          alt=""
        />
        <h4 class="yt-m-comp-title">{{ data.longHeadlines[0] || "Your long headline appears here" }}</h4>
        <a class="yt-m-comp-cta" [href]="data.url || null" target="_blank" rel="noopener noreferrer">{{
          data.ctaText || "Your call to action"
        }}</a>
        <p class="yt-m-comp-desc">{{ data.descriptions[0] || "Your description appears here" }}</p>
      </div>

      <div class="yt-m-comp-dots d-flex flex-row justify-content-center gap-1">
        <span *ngFor="let dot of dots" [class.active]="dot === 0"></span>
      </div>
      <a class="yt-m-comp-btn" [href]="data.url || null" target="_blank" rel="noopener noreferrer">{{
        data.ctaText || "Your call to action"
      }}</a>
    </div>
    <!-- END: Companion card -->
  </div>
</app-mobile-frame>
